import { pdfjs } from 'react-pdf';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

if (!pdfjs.GlobalWorkerOptions.workerSrc) {
//   try {
//     const workerSrc = require('pdfjs-dist/build/pdf.worker.min.js');
//     pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
//   } catch (e) {
//     pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
//   }
// }
// CDN-based or relative path
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
}
export default pdfjs;